import type { ChatPersona } from "@launch10/use-langgraph-stream";

/**
 * The message-lockup personas for every Launch10 chat surface: the
 * blue-and-white Houston tile for the assistant, "You" for the user.
 * The rocket source asset is tinted white via CSS filter; swap in a
 * real white PNG (rocket-white.png) for a crisper tile if we cut one.
 */
export const CHAT_PERSONAS: { assistant: ChatPersona; user: ChatPersona } = {
  assistant: {
    name: "Houston",
    // Mock-matched tile: lighter periwinkle than the app primary, rocket
    // tilted to the mock's ~45° axis. Tilt/tint are one-token dials here.
    tileClassName: "bg-[#6C5BD9]",
    avatar: (
      <img
        src="/images/rocket.svg"
        alt=""
        className="size-4 brightness-0 invert"
      />
    ),
  },
  user: { name: "You" },
};
